import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Header,
  TextField,
  Button,
  XLText,
  XMText,
  FlexWrapper,
  StyledLink,
  FlexWrap,
  Toast,
  Error
} from '../components'
import { Formik, Form, Field } from 'formik'
import axios from 'axios'
import { API_URL } from '../constants'
import { resetPasswordValidator } from '../utlis/validators'
import { get } from 'lodash'

const FormikForm = styled(Form)`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

class ResetPassword extends Component {
  state = { isLoading: false, error: '', openToast: false, message: '' }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.props.history.push('/auth/login')
  }
  render() {
    const { isLoading, error, openToast, message } = this.state
    return (
      <React.Fragment>
        <Header icon="arrowBack" onClickBack={() => this.props.history.goBack()} backgroundColor="transparent" />
        <FlexWrap
          viewPadding={'24px 30px 0'}
          viewMargin="60px 0 0"
          justifyContent="space-between"
          alignItems="center"
          height="calc(100% - 60px)">
          <FlexWrapper width="100%" alignItems="center">
            <XLText>Reset Password!</XLText>
            <FlexWrapper viewPadding="8px 0 0" flexBasis="auto" alignItems="center" />
            <Formik
              enableReinitialize
              initialValues={{
                password: ''
              }}
              validate={resetPasswordValidator}
              validateOnChange
              onSubmit={async (values, { resetForm }) => {
                this.setState({ isLoading: true, error: '' })
                try {
                  const { data } = await axios.post(`${API_URL}/users/custom-reset-password`, {
                    userId: this.props.match.params.id,
                    token: this.props.match.params.token,
                    password: values.password
                  })
                  await this.setState({ isLoading: false, openToast: true, message: get(data, 'message', '') })
                  if (get(data, 'status', '') === 200) {
                    resetForm()
                  }
                } catch (error) {
                  this.setState({ isLoading: false, error: get(error.response, 'data.error.message', '') })
                }
              }}
              render={formikBag => (
                <FormikForm>
                  <Field
                    name="password"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="password"
                        label="Password"
                        required
                        error={formikBag.errors.password}
                      />
                    )}
                  />
                  <Button
                    volume="filled"
                    type="submit"
                    label="Submit"
                    isLoading={isLoading}
                    disabled={isLoading}
                    margin="16px 0 0"
                  />
                  <Error response>{error}</Error>
                  <StyledLink to="/auth/login" onClick={() => this.setState({ error: '' })}>
                    Go to Login
                  </StyledLink>
                </FormikForm>
              )}
            />
          </FlexWrapper>
          <FlexWrapper viewPadding={'0 0 16px 0'} alignItems="center">
            <XMText>
              No account?{' '}
              <StyledLink to="/auth/social-login" onClick={() => this.setState({ error: '' })}>
                Create one
              </StyledLink>
            </XMText>
          </FlexWrapper>
        </FlexWrap>
        <Toast open={openToast} message={message} slideFromTop onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/pages/ResetPassword.js